import { PayloadAction, SliceCaseReducers, createSlice } from '@reduxjs/toolkit';
import { BookingInterface, customerDetailsInterface } from '../types/types';
import { newStateFromFlatBooking } from '../components/utils/stateHelper';
import { setBookingStateFromFlat } from './gunOptionSlice';

export const customerDetailsSlice = createSlice<customerDetailsInterface, SliceCaseReducers<customerDetailsInterface>>({
    name: 'customerDetails',
    initialState: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        activity: '',
        coupon: undefined,
        needInvoice: undefined,
        subscribe: false,
    },
    reducers: {
        /**
         * Input object with attributes to overwrite
         */
        setCustomerDetails: (state, action) => {
            const partialObj = action.payload;
            return {
                ...state,
                ...partialObj
            }
        }
    },
    extraReducers(builder) {
        builder.addCase(setBookingStateFromFlat, (state, action) => {
            const newState = newStateFromFlatBooking(state, action.payload);
            return newState as customerDetailsInterface;
        })
    }
});

export const { setCustomerDetails } = customerDetailsSlice.actions;
export default customerDetailsSlice.reducer;